import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { makeStyles } from 'tss-react/mui';

const standardProps = { disableUnderline: true, readOnly: true };
const outlinedProps = { readOnly: true };

const useStyles = makeStyles()(() => ({
  hideBorder: {
    '& div': {
      border: '0',
      background: 'none',
      '& fieldset, &:hover, &.Mui-focused,  &:hover:not(.Mui-focused)': {
        borderColor: 'transparent !important',
        border: '0',
        background: 'none',
        cursor: 'default !important',
      },
    },
  },
}));

function ReadOnlyField(props) {
  const { readOnly = true, ...otherProps } = props;
  const { classes, cx } = useStyles();
  return (
    <TextField
      variant='filled'
      margin='normal'
      sharedcomponentid='ReadOnlyField'
      {...(readOnly && { tabIndex: -1 })}
      {...otherProps}
      className={cx(readOnly && classes.hideBorder, props.className)}
      InputProps={{
        ...(readOnly && (otherProps?.variant === 'filled' ? standardProps : outlinedProps)),
        ...props.InputProps,
      }}
      InputLabelProps={{
        ...(readOnly && { focused: false }),
        ...props.InputLabelProps,
      }}
    />
  );
}

ReadOnlyField.propTypes = {
  readOnly: PropTypes.bool,
  className: PropTypes.string,
  InputProps: PropTypes.object,
  InputLabelProps: PropTypes.object,
};

export default memo(ReadOnlyField);
